import { createApp } from 'vue'
import { UserLoginService } from '../services/userLogin'
import { useAppState } from '../stores/AppState'

function createAndMountComponent(Component: any, containerId: string) {
  const container = document.createElement('div')
  container.id = containerId
  document.body.appendChild(container)

  const app = createApp(Component as any)
  app.mount(`#${containerId}`)
}

export async function showSplashScreen() {
  const { default: SplashScreen } = await import('../views/SplashScreenView.vue')
  createAndMountComponent(SplashScreen, 'splash-screen-container')
}

export function hideSplashScreen() {
  const splashScreenContainer = document.getElementById('splash-screen-container')
  if (splashScreenContainer) {
    document.body.removeChild(splashScreenContainer)
  }
}

export async function showNoAccessPage() {
  const { default: Unauthorized } = await import('../views/NoAccessView.vue')
  document.body.innerHTML = ''
  createAndMountComponent(Unauthorized, 'unauthorized-page-container')
}

export async function showErrorPage() {
  const { default: ErrorPage } = await import('../views/ErrorPageView.vue')
  document.body.innerHTML = ''
  createAndMountComponent(ErrorPage, 'error-page-container')
}

export async function checkLoginAndHandleSplashScreen() {
  const appState = useAppState()
  const userLoginService = new UserLoginService()
  const allowedToLogin = await userLoginService.allowedToLogin(appState.emailAddress)
  if (!allowedToLogin) {
    await showNoAccessPage()
  }
  hideSplashScreen()
}
